import { render, staticRenderFns } from "./UnderlineTitle.vue?vue&type=template&id=47ff2374&scoped=true&"
import script from "./UnderlineTitle.vue?vue&type=script&lang=js&"
export * from "./UnderlineTitle.vue?vue&type=script&lang=js&"
import style0 from "./UnderlineTitle.vue?vue&type=style&index=0&id=47ff2374&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ff2374",
  null
  
)

export default component.exports